module.exports = __webpack_public_path__ + "static/media/jo.1ea89f77.svg";